import { useState } from "react";
import { mensagemDeErro, rpc } from "../lib/rpc";
import { fmtNum } from "../lib/formato";
import { Botao, Campo, MensagemErro } from "./ui";

/** Pedido de reposição feito à mão (ex: separador achou o picking vazio). */
export function PedirReposicao({ posicaoInicial = "", produtoInicial = "" }: { posicaoInicial?: string; produtoInicial?: string }) {
  const [aberto, setAberto] = useState(false);
  const [posicao, setPosicao] = useState(posicaoInicial);
  const [produto, setProduto] = useState(produtoInicial);
  const [qtd, setQtd] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  async function pedir() {
    setOcupado(true);
    setErro(null);
    setOk(null);
    try {
      const r = await rpc<{ ok: boolean; mensagem?: string; ja_existia?: boolean; tarefa?: { origem: string; destino: string; qtd_solicitada: number } }>(
        "wms_reposicao_solicitar", { p_codigo_local: posicao, p_codigo_produto: produto, p_quantidade: qtd ? Number(qtd) : null });
      if (!r.ok) setErro(r.mensagem ?? "Pedido recusado");
      else if (r.ja_existia) setOk("Já havia uma reposição para esta posição. Ela subiu na fila.");
      else setOk(`Reposição criada: ${fmtNum(r.tarefa?.qtd_solicitada)} un de ${r.tarefa?.origem} para ${r.tarefa?.destino}`);
    } catch (e) {
      setErro(mensagemDeErro(e));
    } finally {
      setOcupado(false);
    }
  }

  if (!aberto) return <Botao variante="secundario" onClick={() => setAberto(true)}>Pedir reposição</Botao>;

  return (
    <div data-dialogo-aberto className="fixed inset-0 z-40 flex items-end justify-center bg-tinta/60 p-4 sm:items-center" role="dialog" aria-modal="true" aria-label="Pedir reposição">
      <div className="w-full max-w-md rounded-lg border-2 border-tinta bg-chapa p-5">
        <h2 className="font-sinal text-2xl font-bold">Pedir reposição</h2>
        <p className="text-aco-escuro">A tarefa vai para a coletora do estoquista, com prioridade.</p>
        <div className="mt-3 flex flex-col gap-3">
          <Campo rotulo="Posição de picking ou packing" value={posicao} onChange={(e) => setPosicao(e.target.value.toUpperCase())} autoFocus />
          <Campo rotulo="Produto (SKU ou código de barras)" value={produto} onChange={(e) => setProduto(e.target.value)} />
          <Campo rotulo="Quantidade (vazio: até o máximo)" type="number" min={1} value={qtd} onChange={(e) => setQtd(e.target.value)} />
          <MensagemErro>{erro}</MensagemErro>
          {ok && <p className="rounded-md bg-ok-claro px-3 py-2 font-semibold text-ok" role="status">{ok}</p>}
        </div>
        <div className="mt-4 flex flex-wrap justify-end gap-2">
          <Botao variante="secundario" onClick={() => { setAberto(false); setOk(null); setErro(null); }}>Fechar</Botao>
          <Botao disabled={ocupado || !posicao || !produto} onClick={() => void pedir()}>Pedir</Botao>
        </div>
      </div>
    </div>
  );
}
